import type { AsyncBelongsTo } from '@ember-data/model';
import { belongsTo } from '@ember-data/model';
import { apiAction } from '@mainmatter/ember-api-actions';
import AbstractPrinter from 'garaje/models/abstract/printer';
import type LocationModel from 'garaje/models/location';
import type VisitorEntranceModel from 'garaje/models/visitor-entrance';
import type { CollectionResponse } from 'jsonapi/response';

class Printer extends AbstractPrinter {
  @belongsTo('visitor-entrance', { async: true, inverse: null })
  declare visitorEntrance: AsyncBelongsTo<VisitorEntranceModel>;
  @belongsTo('location', { async: true, inverse: 'printers' }) declare location: AsyncBelongsTo<LocationModel>;

  get locationName(): string {
    let returnValue = '';
    try {
      // @ts-expect-error - belongsTo method accepts string for relationship name
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const location = this.belongsTo('location').value() as LocationModel | null;
      if (location?.name) {
        returnValue = location.name;
      }
    } catch (_e) {
      // Location not loaded, leave as empty string
    }
    return returnValue;
  }

  async reprintBadge(options: {
    data: Array<{ type: string; id: string }>;
  }): Promise<CollectionResponse<{ result: string; statuses: string[] }>> {
    return await apiAction<CollectionResponse<{ result: string; statuses: string[] }>>(this, {
      method: 'POST',
      path: 'badge-print-jobs',
      data: options,
    });
  }

  toDataForCsvExport(): Record<string, string> {
    return {
      Name: this.name || '',
      'IP Address': this.ip || '',
      Model: this.model || '',
      Location: this.locationName,
      Status: this.statusDisplay,
      'Connection Type': this.connectionType || '',
    };
  }
}

export default Printer;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    printer: Printer;
  }
}
